import { getNewbuildingChatContacts } from '@cian/newbuilding-chat-component';

import { IApplicationState } from '../../types/redux';
import { getBuilders, getSellers } from '../newbuilding';

export const getBuilderChatEnabled = (state: IApplicationState): boolean => {
  const builders = getBuilders(state);
  const sellers = getSellers(state);
  const chatContacts = getNewbuildingChatContacts(builders, sellers);

  return chatContacts.length > 0;
};
